import { render, staticRenderFns } from "./ActivityPageBannerScroll.vue?vue&type=template&id=8d36d8ec&scoped=true&"
import script from "./ActivityPageBannerScroll.vue?vue&type=script&lang=js&"
export * from "./ActivityPageBannerScroll.vue?vue&type=script&lang=js&"
import style0 from "./ActivityPageBannerScroll.vue?vue&type=style&index=0&id=8d36d8ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d36d8ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
